@if (component) {
<div class="video-component pos-relative overflow-hidden"
     [ngClass]="[component.ratio || '']">

    <!-- image -->
    @if (component.backgroundImage) {
    <shell></shell>

    <img class="z-1"
         [ratio]="component.ratio"
         [fill]="true"
         [dfImage]="component.backgroundImage">
    }

    @if (component.videoId) {
    @if (component.videoProvider === 'youtube') {
    <youtube-player class="z-2"
                    [class.rf]="!!component.ratio"
                    [video-id]="component.videoId"
                    [autoplay-in-viewport]="component.videoAutoplay"
                    [background]="component.videoBackground">
        <!-- play icon -->
        <ng-template #playButton>
            <i class="icon-play"></i>
        </ng-template>

        <!-- pause icon -->
        <ng-template #pauseButton>
            <i class="icon-pause"></i>
        </ng-template>
    </youtube-player>
    }

    @if (component.videoProvider === 'vimeo') {
    <vimeo-player class="z-2"
                  [class.rf]="!!component.ratio"
                  [video-id]="component.videoId"
                  [autoplay-in-viewport]="component.videoAutoplay"
                  [background]="component.videoBackground">
        <!-- play icon -->
        <ng-template #playButton>
            <i class="icon-play"></i>
        </ng-template>

        <!-- pause icon -->
        <ng-template #pauseButton>
            <i class="icon-pause"></i>
        </ng-template>
    </vimeo-player>
    }
    }
</div>
}